import dayjs from "dayjs";

import {
  HotelsSortOptions,
  type HotelsSortValue,
  type THotelFormFieldValues,
} from "@/features/hotels/types/types";
import { SortOrder, TravelPurpose } from "@/types/enums";

export const initialHotelsValues: THotelFormFieldValues = {
  destination: null,
  dates: {
    checkIn: dayjs().add(1, "day").startOf("day").toDate(),
    checkOut: dayjs().add(2, "day").startOf("day").toDate(),
  },
  rooms: [
    {
      adults: 1,
      children: 0,
      childrenAges: [] as number[],
    },
  ],
  travelPurpose: TravelPurpose.LEISURE,
};

export const initialSortValue: HotelsSortValue = {
  field: HotelsSortOptions.RECOMMENDED,
  order: SortOrder.ASC,
};
